import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Styles } from "../styles.js";
import Button from "../../../components/shared/Button.jsx";
import BreadcrumbBox from "../../../components/common/Breadcrumb.jsx";
import { useLanguageDetector } from "../../../hooks/useLanguageDetector.js";
import EnglishData from "../../../data/summer-school/data.json";
import RussianData from "../../../data/summer-school/data-ru.json";
import UzbekData from "../../../data/summer-school/data-uz.json";
import Heading from "../../../components/shared/Heading.jsx";
import { Container } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { colors } from "../../../components/common/element/elements.js";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const allTopics = {
  research_planning: "research_planning",
  critical_thinking: "critical_thinking",
};

const SummerResearchSchool = () => {
  const navigate = useNavigate();
  const [topic, setTopic] = useState("research_planning");

  const [allData] = useLanguageDetector(EnglishData, RussianData, UzbekData);
  const { t } = useTranslation();
  const data = allData?.research;

  const planData = data[allTopics[topic]];

  return (
    <Styles>
      <BreadcrumbBox
        title={data?.title}
        image="/assets/images/research_school_1.webp"
        preTitle={data?.subtitle}
        centerTitle={true}
        registerButton={true}
        registerLink="/summer-research-school-form"
      />
      <Container>
        <section className="summer-school-section research-school">
          <div className="subtitle">
            <p className="pb-2">{data?.paragraph1}</p>
          </div>

          <div className="goals mb-5 pb-3">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.goals?.title}
            />
            <ul className="list-unstyled">
              {data?.goals?.list.map((item, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <div>
                    <Icon
                      icon="ph:paper-plane-right-duotone"
                      fontSize={20}
                      color={colors.bg2}
                    />
                  </div>
                  <p className="ps-3">{item}</p>
                </li>
              ))}
            </ul>
            <p>{data?.goals?.subtitle}</p>
          </div>

          <div className="d-flex gap-3">
            <CustomButton
              className={topic === "research_planning" && "active"}
              text={data?.research_planning?.title}
              onClick={() => setTopic("research_planning")}
            ></CustomButton>
            <CustomButton
              className={topic === "critical_thinking" && "active"}
              text={data?.critical_thinking?.title}
              onClick={() => setTopic("critical_thinking")}
            ></CustomButton>
          </div>

          <div className="details pt-5">
            <div className="details-list">
              {planData?.details?.map((item, index) => (
                <p className="item" key={index}>
                  <b>{item?.label}</b> <span>{item?.value}</span>
                  <span className="fw-bold">{item?.subvalue}</span>
                </p>
              ))}
            </div>
          </div>

          <div className="syllabus">
            <Heading
              tag="h4"
              className="strategy-title"
              title={planData?.syllabus?.title}
            />

            <div className="syllabus-data">
              {planData?.syllabus?.tables?.map((table, index) => (
                <div key={index}>
                  <h5>
                    <b>{table?.title}</b>
                  </h5>
                  <div>
                    <table className="table table-bordered w-100">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{t("Objective")}</th>
                          <th scope="col">{t("Session Outline")}</th>
                          <th scope="col">{t("Activity")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="w-25">{table.row?.objective}</td>

                          <td className="w-25">
                            {table?.row?.sessionOutline.map((item, i) => (
                              <p key={i} className="pb-2">
                                - {item}
                              </p>
                            ))}
                          </td>

                          <td className="w-25">
                            {table?.row?.activity.map((item, i) => (
                              <p key={i} className="pb-2">
                                - {item}
                              </p>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="post-class-task">
            <Heading
              tag="h4"
              className="strategy-title"
              title={planData?.postClassTask?.title}
            />

            <div className="post-class-task-data">
              {planData?.postClassTask?.data?.map((task, index) => (
                <div key={index} className="pb-3">
                  <h5 className="fw-bold border-bottom pb-2">{task?.title}</h5>
                  <ul className="list-unstyled">
                    {task?.list?.map((item, i) => (
                      <li className="d-flex mb-3 item" key={i}>
                        <div>
                          <Icon
                            icon="ph:paper-plane-right-duotone"
                            fontSize={20}
                            color={colors.bg2}
                          />
                        </div>
                        <p className="ps-3">{item}</p>
                      </li>
                    ))}
                  </ul>
                  <p className="fs-6">{task?.subtitle}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="py-5 d-flex justify-content-center">
            <Button
              className={"apply-button"}
              text={"Register now"}
              onClick={() => navigate("/summer-research-school-form")}
            ></Button>
          </div>
        </section>
      </Container>
    </Styles>
  );
};

export default SummerResearchSchool;

const CustomButton = styled(Button)`
  border: 1px solid ${colors.bg1};
  border-radius: 6px;
  padding: 8px 32px;
  cursor: pointer;
  background: transparent;
  color: ${colors.bg1};
  font-weight: 600;
  font-size: 20px;
  &:hover {
    transform: none !important;
    background: transparent !important;
  }
  &.active {
    background: ${colors.bg1};
    color: white;
    &:hover {
      background: ${colors.bg1} !important;
    }
  }
`;
